export default __webpack_public_path__ + "static/media/welcome-image.78e675ba.png";